import { createRouter, createWebHistory, RouteRecordRaw } from "vue-router";

import * as constant from "@/assets/constant";
import Login from "@/views/Login.vue";
import Home from "@/views/home/Home.vue";
import DashBoard from "@/views/dashboard/DashBoard.vue";
import Product from "@/views/product/Product.vue";
import PersonalProduct from "@/views/product/personal/ProductGroup.vue";
import Organization from "@/views/organization/Organization.vue";
import Personal from "@/views/personal/Personal.vue";
import OrgOrder from "@/views/order/org/Order.vue";
import OrgOrderQuotation from "@/views/order/org/OrderQuotation.vue";
import OrgOrderRegister from "@/views/order/org/OrderRegister.vue";
import OrgOrderEdit from "@/views/order/org/OrderEdit.vue";

import PersonalOrder from "@/views/order/personal/Order.vue";
import OrgDiagnosis from "@/views/diagnosis/org/Diagnosis.vue";
import PersonalDiagnosis from "@/views/diagnosis/personal/Diagnosis.vue";

import OrgPayment from "@/views/payment/org/Payment.vue";
import PersonalPayment from "@/views/payment/personal/Payment.vue";
import Notice from "@/views/notice/Notice.vue";
import Qna from "@/views/qna/Qna.vue";
import Press from "@/views/press/Press.vue";
import Myreg from "@/views/myreg/Myreg.vue";
import OrgMyreg from "@/views/myreg/OrgMyreg.vue";

import Sales from "@/views/sales/Sales.vue";
import Statistics from "@/views/statistics/Statistics.vue";
import { USER_ROUTES } from "@/assets/route_constants";
import { firebaseAuth } from "@/config/env";

const routes: Array<RouteRecordRaw> = [
    {
        path: USER_ROUTES.Login.Path,
        name: USER_ROUTES.Login.Name,
        component: Login,
    },
    {
        path: USER_ROUTES.Home.Path,
        name: USER_ROUTES.Home.Name,
        component: Home,
        meta: { requiresAuth: true },
        children: [
            {
                path: USER_ROUTES.DashBoard.Path,
                name: USER_ROUTES.DashBoard.Name,
                component: DashBoard,
                meta: { requiresAuth: true },
            },
            {
                path: USER_ROUTES.Product.Path,
                name: USER_ROUTES.Product.Name,
                component: Product,
                meta: { requiresAuth: true },
            },
            {
                path: USER_ROUTES.PersonalProduct.Path,
                name: USER_ROUTES.PersonalProduct.Name,
                component: PersonalProduct,
                meta: { requiresAuth: true },
            },
            {
                path: USER_ROUTES.Organization.Path,
                name: USER_ROUTES.Organization.Name,
                component: Organization,
                meta: { requiresAuth: true },
            },
            {
                path: USER_ROUTES.Personal.Path,
                name: USER_ROUTES.Personal.Name,
                component: Personal,
                meta: { requiresAuth: true },
            },
            {
                path: USER_ROUTES.OrgOrderQuotation.Path,
                name: USER_ROUTES.OrgOrderQuotation.Name,
                component: OrgOrderQuotation,
                meta: { requiresAuth: true },
            },
            {
                path: USER_ROUTES.OrgOrder.Path,
                name: USER_ROUTES.OrgOrder.Name,
                component: OrgOrder,
                meta: { requiresAuth: true },
            },
            {
                path: USER_ROUTES.OrgOrderRegister.Path,
                name: USER_ROUTES.OrgOrderRegister.Name,
                component: OrgOrderRegister,
                meta: { requiresAuth: true },
            },
            {
                path: USER_ROUTES.OrgOrderEdit.Path,
                name: USER_ROUTES.OrgOrderEdit.Name,
                component: OrgOrderEdit,
                meta: { requiresAuth: true },
            },
            {
                path: USER_ROUTES.OrgDiagnosis.Path,
                name: USER_ROUTES.OrgDiagnosis.Name,
                component: OrgDiagnosis,
                meta: { requiresAuth: true },
            },
            {
                path: USER_ROUTES.OrgPayment.Path,
                name: USER_ROUTES.OrgPayment.Name,
                component: OrgPayment,
                meta: { requiresAuth: true },
            },
            {
                path: USER_ROUTES.PersonalOrder.Path,
                name: USER_ROUTES.PersonalOrder.Name,
                component: PersonalOrder,
                meta: { requiresAuth: true },
            },
            {
                path: USER_ROUTES.PersonalDiagnosis.Path,
                name: USER_ROUTES.PersonalDiagnosis.Name,
                component: PersonalDiagnosis,
                meta: { requiresAuth: true },
            },
            {
                path: USER_ROUTES.PersonalPayment.Path,
                name: USER_ROUTES.PersonalPayment.Name,
                component: PersonalPayment,
                meta: { requiresAuth: true },
            },
            {
                path: USER_ROUTES.Notice.Path,
                name: USER_ROUTES.Notice.Name,
                component: Notice,
                meta: { requiresAuth: true },
            },
            {
                path: USER_ROUTES.Qna.Path,
                name: USER_ROUTES.Qna.Name,
                component: Qna,
                meta: { requiresAuth: true },
            },
            {
                path: USER_ROUTES.Press.Path,
                name: USER_ROUTES.Press.Name,
                component: Press,
                meta: { requiresAuth: true },
            },
            {
                path: USER_ROUTES.Myreg.Path,
                name: USER_ROUTES.Myreg.Name,
                component: Myreg,
            },

            {
                path: USER_ROUTES.OrgMyreg.Path,
                name: USER_ROUTES.OrgMyreg.Name,
                component: OrgMyreg,
                meta: { requiresAuth: true },
            },
            {
                path: USER_ROUTES.Sales.Path,
                name: USER_ROUTES.Sales.Name,
                component: Sales,
                meta: { requiresAuth: true },
            },
            {
                path: USER_ROUTES.Statistics.Path,
                name: USER_ROUTES.Statistics.Name,
                component: Statistics,
                meta: { requiresAuth: true },
            },
        ],
    },
];

let firebaseAuthIsReadyResolve: ((value: void) => void) | null = null;
const firebaseAuthIsReady = new Promise<void>((resolve) => {
    firebaseAuthIsReadyResolve = resolve;
});

firebaseAuth.onAuthStateChanged((user) => {
    if (firebaseAuthIsReadyResolve) {
        firebaseAuthIsReadyResolve();
        firebaseAuthIsReadyResolve = null;
    }
});

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes,
});

router.beforeEach(async (to, from, next) => {
    await firebaseAuthIsReady;
    const isAuthenticated = firebaseAuth.currentUser ? true : false;
    // console.log("Router Guard: to.meta.requiresAuth : ", to.meta.requiresAuth, ", isAuthenticated : ", isAuthenticated);
    if (to.meta.requiresAuth && !isAuthenticated) {
        // console.log("Router Guard: Redirecting to login");
        next(USER_ROUTES.Login.Path);
    } else {
        next();
    }
});

export default router;
